// A browser tab has no app icon to badge. expo-notifications' badge module is not implemented for
// web at all, and the platform alternative — the Badging API — only applies to an installed PWA
// with a service worker, which this build does not ship. So the honest web implementation is to do
// nothing; the unread count is still visible in the header bell and on the inbox screen itself.

export async function setAppBadgeCount(_count: number): Promise<void> {
    // Intentionally empty — see the file comment.
}
